import { createSlice } from '@reduxjs/toolkit';

const initialImgCodeState = { img: null };

const qrImageSlice = createSlice({
  name: 'qrImg',
  initialState: initialImgCodeState,
  reducers: {
    store(state, action) {
      state.img = action.payload;
    },
    reset(state, action){
      state.img = null;
    }
  }
});

export const qrImageActions = qrImageSlice.actions;

export default qrImageSlice.reducer;